import React, { useEffect } from "react";
import styled from "styled-components/macro";

const Scrolltotop = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return <>{children}</>;
};

export default Scrolltotop;
